import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, JsonViewer } from "../../../molecules";
import { MODAL_SIZE } from "../modals.constants";
import { actions as modalActions } from "../../Modal/modal.reducers";
import { selectCollection } from "../../../../pages/DataModels";
import { EMPTY_STRING } from "../../../../constants";

const { setSelectedModal } = modalActions;
const { MD } = MODAL_SIZE;

const CollectionSchemaModal = () => {
  const dispatch = useDispatch();
  const selectedCollection = useSelector(selectCollection);

  const [collection, setCollection] = useState({ name: EMPTY_STRING });
  const [schema, setSchema] = useState();
  const [collectionProperties, setCollectionProperties] = useState();

  useEffect(() => {
    if (selectedCollection) {
      setCollection(selectedCollection);
      setCollectionProperties(selectedCollection.schema.properties);
    }
  }, [selectedCollection]);

  const getFormattedProperties = useCallback((properties) => {
    const formattedProperties = properties.reduce((acc, property) => {
      return { ...acc, [property.schema.key]: property.schema.type };
    }, {});
    return formattedProperties;
  }, []);

  useEffect(() => {
    if (collectionProperties)
      setSchema({
        id: typeof collection.id,
        name: typeof collection.name,
        properties: getFormattedProperties(collectionProperties),
      });
  }, [collection, getFormattedProperties, collectionProperties]);

  const handleClose = useCallback(
    () => dispatch(setSelectedModal(null)),
    [dispatch]
  );

  const footer = (
    <div className="p-6 border-t border-gray-700 text-right">
      <button
        className="btn btn-primary-light"
        type="submit"
        onClick={handleClose}
      >
        Close
      </button>
    </div>
  );

  return (
    <>
      <Modal
        title={`${collection.name} Schema`}
        handleClose={handleClose}
        size={MD}
        footer={footer}
      >
        <div className="p-6 rounded-lg">
          <JsonViewer
            value={schema}
            className="border border-gray-700 !text-base bg-gray-900 max-h-80 overflow-auto no-scrollbar"
          />
        </div>
      </Modal>
    </>
  );
};

export default CollectionSchemaModal;
